import { Callout } from './components/callout.tsx'
import { Xcelera } from './components/xcelera.tsx'

export const meta = () => [
	{ title: 'Docs · xcelera' },
	{
		name: 'description',
		content:
			'Overview of xcelera, a lightweight performance monitoring tool built on Chrome Lighthouse, with links to the full docs.',
	},
]

# Introduction

<Xcelera /> is a lightweight, developer-friendly performance monitoring tool
built on Chrome Lighthouse.

## Why does <Xcelera /> exist?

More code is being shipped than ever, but it's mostly not being written with performance in mind. Without careful monitoring, regressions compound quietly until long load times are normalized. Most performance tooling is built for enterprise budgets. <Xcelera /> gives small teams a cost-effective way to continuously audit their pages so problems surface early.

## What can it do?

- **[Diagnose slow pages](/docs/ai-diagnosis)** — Get an AI root-cause diagnosis with evidence and fixes for your stack
- **[Schedule audits](/docs/scheduling)** — Set up daily or hourly Lighthouse audits for any page
- **[Track trends](/docs/performance-monitoring)** — Monitor Performance, Accessibility, Best Practices, and SEO scores over time
- **[Integrate with GitHub](/docs/github-integration)** — Get performance check runs on every pull request
- **[Trigger via API](/docs/api-usage)** — Run audits programmatically from your CI pipeline or CLI
- **[Audit secure pages](/docs/secure-pages)** — Authenticate against pages behind a login
- **[Connect via webhooks](/docs/webhooks)** — Push audit results to Slack, low code tools, or any external system

<Callout type="tip">
	New here? Start with the [Getting Started](/docs/getting-started) guide to add
	your first page and run an audit.
</Callout>
